<!--
 * @description  : 
 * @Author       : Junfeng Fu
 * @Date         : 2022-11-30 14:16:31
 * @LastEditors  : Junfeng Fu
 * @LastEditTime : 2022-12-12 09:29:00
-->
<template>
    <div class="changeSuccess">
        <h1 class="title">账号安全设置</h1>
        <div class="complete">
            <div>
                <p style="margin:0;">
                    <img src="../../assets/complete2.png" />
                </p>
                <p class="friendly-tips">密码修改成功，可以开始学习啦！</p>
                <!-- <p style="font-size:16px;color:#333333;margin-bottom:45px;">当前你的密码安全性低，就差一步就可以完成密码修改！</p> -->
            </div>
            <el-button type="primary" @click="startStudy">开始学习</el-button>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
        }
    },
    created () {
        if (sessionStorage.hasChecked !== 'setSuccess') {
            this.$router.push('/')
        }
    },
    mounted () {
    },
    methods: {
        startStudy () {
            let OBJ = {
                '0': '/Err404',
                '1': '/EducationManagemant/trainClassManage',
                '2': '/trainClass/personalCenter/learnCenter/mockTest',
                '3': '/trainClass/personalCenter/learnCenter/mockTest',
            }
            this.$router.push(OBJ[sessionStorage.btnsStatus])
        }
    }
}
</script>
<style lang="scss">
.changeSuccess {
  width: 1020px;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  .title {
    font-weight: normal;
    font-size: 24px;
    margin: 30px 40px;
    color: #333333;
    border-bottom:1px solid #eeeeee;
    padding-bottom: 20px;
  }
  .complete {
    text-align: center;
    img {
      margin: 50px 0 30px 0;
    }

    .el-button {
      margin-top: 90px;
      background-color: #1060ab;
    }

    .friendly-tips {
      margin-left: 10px;
      font-size: 24px;
      margin: 0;
      margin-bottom: 20px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/saftySetting/changeSuccess.vue